// mixin.js

import $ from "jquery";

export default {
    data() {
        return {
            startAnimation: false,
            lastScroll: 0,
            scrollDelay: null
        }
    },
    mounted() {
        this.startAnimation = true;
    },
    methods: {
        pageScroll(e) {
            clearTimeout(this.scrollDelay);
            this.scrollDelay = setTimeout(this.calcScroll, 100);
        },
        calcScroll(){
            if ( this.$refs.page && Math.abs(this.lastScroll  - $(this.$refs.page).scrollTop()) > 100 ){
                if (this.lastScroll  > $(this.$refs.page).scrollTop()  ){
                    this.$store.commit("shared/changeHeaderClass",  "" )
                } else{
                    this.$store.commit("shared/changeHeaderClass", "hidden")
                }
                this.lastScroll = $(this.$refs.page).scrollTop();
            }
        },
        changePageTitle(title){
            document.title = title;
        }
    }
};
